module.exports = __webpack_public_path__ + "img/switch.b192844f.gif";